import { api } from '..';
import { AdvancedQueryTypes, ResponseType } from '../../types/shared.types';
import {
  GetBrandOwnerDashboardBestPerformingParams,
  GetBrandOwnerDashboardCustomerOverviewParams,
  GetBrandOwnerDashboardTodayParams,
  BestPerformingLocationsEntity,
  OrdersTodayInfoEntity,
  BestPerformingStateEntity,
  BestPerformingProviderEntity,
  CustomersOverviewEntity,
  GetBrandOwnerDashboardOverviewParams,
  OrdersOverviewEntity,
  GetPartnerDashboardOverviewParams,
  GetPartnerDashboardTodayParams,
  ComparedOrdersOverviewEntity,
} from '../../types/brandOwner';
import { GetDashboardComparedOverviewParams } from '../../types/dashboard.types';

export const getPartnerAdvanceQueryTypes = () =>
  api.get<ResponseType<AdvancedQueryTypes[]>>(
    `/v2/dashboard/partner/brand/advanced-query-types`
  );

export const getPartnerDashboardOverview = (
  params: GetPartnerDashboardOverviewParams
) =>
  api.get<ResponseType<OrdersOverviewEntity>>(
    `/v2/dashboard/partner/orders/overview`,
    {
      params,
    }
  );

export const getPartnerDashboardOrdersToday = (
  params: GetPartnerDashboardTodayParams
) =>
  api.get<ResponseType<OrdersTodayInfoEntity>>(
    `/v2/dashboard/partner/orders/today`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardAdvancedQueryTypes = () =>
  api.get<ResponseType<AdvancedQueryTypes[]>>(
    `/v2/dashboard/partner/brand/brand-owner/advanced-query-types`
  );

export const getBrandOwnerDashboardOrdersToday = (
  params: GetBrandOwnerDashboardTodayParams
) =>
  api.get<ResponseType<OrdersTodayInfoEntity>>(
    `/v2/dashboard/brand-owner/orders/today`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardOverview = (
  params: GetBrandOwnerDashboardOverviewParams
) =>
  api.get<ResponseType<OrdersOverviewEntity>>(
    `/v2/dashboard/brand-owner/orders/overview`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardComparedOverview = (
  params: GetDashboardComparedOverviewParams
) =>
  api.get<ResponseType<ComparedOrdersOverviewEntity>>(
    `/v2/dashboard/brand-owner/orders/compared-overview`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardBestPerformingLocations = (
  params: GetBrandOwnerDashboardBestPerformingParams
) =>
  api.get<ResponseType<BestPerformingLocationsEntity[]>>(
    `/v2/dashboard/brand-owner/orders/best-performing-locations`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardBestPerformingStates = (
  params: GetBrandOwnerDashboardBestPerformingParams
) =>
  api.get<ResponseType<BestPerformingStateEntity[]>>(
    `/v2/dashboard/brand-owner/orders/best-performing-states`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardBestPerformingProviders = (
  params: GetBrandOwnerDashboardBestPerformingParams
) =>
  api.get<ResponseType<BestPerformingProviderEntity[]>>(
    `/v2/dashboard/brand-owner/orders/best-performing-providers`,
    {
      params,
    }
  );

export const getBrandOwnerDashboardCustomerOverview = (
  params: GetBrandOwnerDashboardCustomerOverviewParams
) =>
  api.get<ResponseType<CustomersOverviewEntity>>(
    `/v2/dashboard/brand-owner/orders/customers-overview`,
    {
      params,
    }
  );
